"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureToggle = exports.FeatureToggleContext = void 0;
const react_1 = __importDefault(require("react"));
exports.FeatureToggleContext = react_1.default.createContext({
    featureToggleConfig: null,
    isEnabled: () => false,
    getVariant: () => null,
});
function useFeatureToggle() {
    return react_1.default.useContext(exports.FeatureToggleContext);
}
exports.useFeatureToggle = useFeatureToggle;
//# sourceMappingURL=feature-toggle.context.js.map